import { Iconic } from '@/commons/iconic';
import { LinkLabel } from '@/commons/tableFields';
import { CONSTANT_TABLE } from '@/components/Table/list-table/interface';
import { PATH_DASHBOARD, path } from '@/routes/paths';
import { translates } from '@/utils';
import { currentFormat } from '@/utils/cases';
import { formatDateWithTime, parseUserDate } from '@/utils/date';
import { Chip } from '@mui/material';
import { Link } from 'react-router-dom';
import { commonTableDateFormat } from '@/utils/constants';
import { OrderStatus } from '../page/cookingPanel';

export const COLORS = {
  created: 'info',
  cancelled: 'error',
  in_progress: 'info',
  delivered: 'primary',
  pending: 'warning',
  closed: 'success',
  paid: 'success',
  done: 'success',
  cooking: 'secondary',
  error: 'error',
};

export const TABLE_HEAD_ORDERS: (isFoodCompany: boolean) => CONSTANT_TABLE[] = (
  isFoodCompany: boolean
) =>
  isFoodCompany
    ? [
        {
          id: 'status',
          label: translates.pay,
          align: 'left',
          wrapComponent: (value: any, id: string) =>
            value === OrderStatus.Closed ? (
              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <Iconic icon="eva:credit-card-outline" color="gray" />
              </div>
            ) : (
              <Link
                to={PATH_DASHBOARD.orders.checkout(id)}
                style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
              >
                <Iconic icon="eva:credit-card-outline" color="green" />
              </Link>
            ),
        },
        {
          id: 'table',
          label: translates.name,
          align: 'center',
          wrapComponent: (value: string, id: string) => (
            <LinkLabel value={value} cut={value.length} to={PATH_DASHBOARD.orders.view(id)} />
          ),
        },
        {
          id: 'vendor',
          label: translates.waiter,
          align: 'center',
        },
        {
          id: 'tips',
          label: translates.tips,
          align: 'center',
          wrapComponent: (value: number) => currentFormat(value),
        },
        { id: 'discount', label: translates.discount, align: 'center' },
        {
          id: 'total',
          label: translates.total,
          align: 'center',
          wrapComponent: (value: number) => currentFormat(value),
        },
        // { id: 'isTip', label: 'isTip', align: 'center' },
        { id: 'items', label: translates.item, align: 'center' },
        {
          id: 'createdAt',
          label: translates.createdAt,
          align: 'center',
          wrapComponent: (value: string) => formatDateWithTime(value),
        },
        {
          id: 'status',
          label: translates.status,
          align: 'center',
          wrapComponent: (values: string) => (
            <Chip color={COLORS[values as keyof typeof COLORS] as any} label={values} />
          ),
        },
        { id: '', disableSort: true },
      ]
    : [
        {
          id: 'status',
          label: translates.pay,
          align: 'left',
          wrapComponent: (value: any, id: string) =>
            value === OrderStatus.Closed ? (
              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <Iconic icon="eva:credit-card-outline" color="gray" />
              </div>
            ) : (
              <Link
                to={PATH_DASHBOARD.orders.checkout(id)}
                style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
              >
                <Iconic icon="eva:credit-card-outline" color="green" />
              </Link>
            ),
        },
        {
          id: 'table',
          label: translates.name,
          align: 'center',
          wrapComponent: (value: string, id: string) => (
            <LinkLabel value={value} cut={value.length} to={PATH_DASHBOARD.orders.view(id)} />
          ),
        },
        {
          id: 'vendor',
          label: 'Vendedor',
          align: 'center',
        },
        { id: 'discount', label: translates.discount, align: 'center' },
        {
          id: 'total',
          label: translates.total,
          align: 'center',
          wrapComponent: (value: number) => currentFormat(value),
        },
        // { id: 'isTip', label: 'isTip', align: 'center' },
        { id: 'items', label: translates.item, align: 'center' },
        {
          id: 'createdAt',
          label: translates.createdAt,
          align: 'center',
          wrapComponent: (value: string) => formatDateWithTime(value),
        },
        {
          id: 'status',
          label: translates.status,
          align: 'center',
          wrapComponent: (values: string) => (
            <Chip color={COLORS[values as keyof typeof COLORS] as any} label={values} />
          ),
        },
        { id: '', disableSort: true },
      ];

export const STATUS_OPTIONS = [
  { value: 'Activo', label: translates.active },
  { value: 'Desactivado', label: translates.disable },
];

export const PATH_RESERVATION = (ROOTS_DASHBOARD: string) => ({
  root: path(ROOTS_DASHBOARD, '/orders'),
  list: path(ROOTS_DASHBOARD, '/orders/list'),
  view: (name: number) => path(ROOTS_DASHBOARD, `/orders/${name}`),
  edit: (name: number) => path(ROOTS_DASHBOARD, `/orders/${name}/edit`),
});
